import { Button, Popper } from "@mui/material";
import { styled, css } from "@mui/system";

import React, { useEffect, useRef, useState } from "react";

const CustomPopper = ({ btnText, btnClassName, popperData }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const popperRef = useRef(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const openPopup = Boolean(anchorEl);
  const popupId = openPopup ? "simple-popper" : undefined;

  // Detect clicks outside the popper or button
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        anchorEl &&
        !anchorEl.contains(event.target) && // Outside the button
        popperRef.current &&
        !popperRef.current.contains(event.target) // Outside the popper
      ) {
        setAnchorEl(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl]);

  return (
    <div>
      <Button
        aria-describedby={popupId}
        type="button"
        onClick={handleClick}
        className={
          btnClassName ||
          "!border-solid !border-2 !border-primary !text-primary !p-0 !rounded-lg"
        }
      >
        {btnText}
      </Button>
      <Popper
        id={popupId}
        open={openPopup}
        anchorEl={anchorEl}
        ref={popperRef}
        className="z-50"
      >
        <StyledPopperDiv>{popperData}</StyledPopperDiv>
      </Popper>
    </div>
  );
};

export default CustomPopper;

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const StyledPopperDiv = styled("div")(
  ({ theme }) => css`
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: ${theme.palette.mode === "dark"
      ? `0px 4px 8px rgb(0 0 0 / 0.7)`
      : `0px 4px 8px rgb(0 0 0 / 0.1)`};
    padding: 0.75rem;
    color: ${theme.palette.mode === "dark" ? grey[100] : grey[700]};
    font-size: 0.875rem;
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: 500;
    opacity: 1;
    margin: 0.25rem 0;
  `
);
